/**
 Adzuki.SimpleModal
 put a title and body content into a modal, which is a part of the template, without any additional JS

 Example Usage:

  <a href="#custom-id" class="simple-modal" data-title="Hello">Show A Modal</a>

  When this link is clicked, it will:

	1) put "Hello" in the modal title
	2) innerHTML of element with an id of "custom-id" into the modal body. so you'll want this element hidden on the page load
	3) show the modal
 */

(function SimpleModal($, Adzuki)
{
	"use strict";

	var $modal = $('#modalWindow');

	$(document).ready(function documentReady()
	{
		if ($('.simple-modal').length > 0) {
			$('.simple-modal').click(function doModal(e) {
				var $self              = $(this),
				    modal_title        = $self.data('title'),
				    modal_body_id      = $self.attr('href'),
				    modal_body_content = $(modal_body_id).html();

				e.preventDefault();

				$modal.find('.modal-title').html(modal_title);
				$modal.find('.modal-body').html(modal_body_content);
				$modal.find('.modal-body img').css('max-width', '100%');
				$modal.modal('show');
				
				$modal.on('shown.bs.modal', function init(e) {
					Adzuki.MagnifierGlass($(this).find('.adz-magnifier-container'));
				});
			});
		}
	});
}(jQuery, window.Adzuki || {}));
